import React from 'react';
import { useAuth } from '@hooks/useAuth';
import { Menu, X } from 'react-feather';
import { motion } from 'framer-motion';
import { NavHashLink } from 'react-router-hash-link';
import { Link } from 'react-router-dom';
import { useUserStore } from '../models'

const Nav = ({ hide, scroll }) => {
  const { loading } = useAuth();
  const { user } = useUserStore()

  const variants =
    window.innerWidth <= 900
      ? {
          open: { opacity: 1, x: 0 },
          closed: { opacity: 0, x: '-100vw' },
        }
      : {
          open: { opacity: 1, x: 0 },
          closed: { opacity: 1, x: 0 },
        };
  const signout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    window.location.href = '/';
  };

  const [open, setOpen] = React.useState(false);

  return (
    <>
      {window.innerWidth <= 900 && (
        <div className="tab">
          <a href="/">
            <img src="/logo.svg" alt="logo" className="logo" />
          </a>
          <Menu className="menu" color="#fff" onClick={() => setOpen(true)} />
        </div>
      )}
      <motion.nav
        className="header_navigation bg-[#000000] md:bg-[#00000044] backdrop-blur-[.3rem] fixed top-0 left-0 flex flex-col items-center justify-center gap-10 z-[100]"
        variants={variants}
        animate={open ? 'open' : 'closed'}
        initial={'closed'}
        transition={{ duration: 0.8, type: 'spring', ease: 'easeInOut' }}
      >
        <div
          className={`logo_container${window.innerWidth <= 900 && '_mobile'}`}
        >
          <Link to="/">
            <img src="/logo.svg" alt="logo" className="logo" />
          </Link>
          {window.innerWidth <= 900 && (
            <X className="close" color="#fff" onClick={() => setOpen(false)} />
          )}
        </div>
        <ul className="nav_links">
          <li className="nav_link">
            <Link to="/dashboard/?view=dashboard">Dashboard</Link>
          </li>
          <li className="nav_link">
            <NavHashLink to={`/#about`} smooth={true}>
              About
            </NavHashLink>
          </li>
          <li className="nav_link">
            <NavHashLink to={`/#faq`} smooth={true}>
              FAQ
            </NavHashLink>
          </li>
          <li className="nav_link">
            <NavHashLink to={`/#contacts`} smooth={true}>
            Contacts
            </NavHashLink>
          </li>
        </ul>
        <div className="button_group">
          {loading ? null : user ? (
            <button className="button" onClick={signout}>
              Sign out
            </button>
          ) : (
            <>
              <Link to="/auth/signin" className="button">
                Sign in
              </Link>
              <Link to="/auth/signup" className="button">
                Sign up
              </Link>
            </>
          )}
        </div>
      </motion.nav>
    </>
  );
};

export default Nav;
